
import AlertBoxComponent from '@/components/AlertBox/AlertBoxComponent';
export default AlertBoxComponent;
